import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Locker } from "../../shared/data.service";
import { LockerExistsRequest } from "../../shared/LockerExistsRequest";
import { LockerInsertMultipleRequest } from "../../shared/LockerInsertMultipleRequest";
import { LockerInsertSingleRequest } from "../../shared/LockerInsertSingleRequest";

@Component({
	selector: "app-add-locker",
	templateUrl: "./add-locker.component.html",
	styleUrls: ["./add-locker.component.css"],
})
export class AddLockerComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private LockerService: DataService_Locker
	) {}

	ngOnInit(): void {
		this.School = this.dialogConfig.data.School;
		this.SchoolName = this.School.SchoolName;

		this.loadPaddingOption();
	}

	//////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////

	School: any;
	SchoolName: any = "";

	LockerOption: any = "Range"; //Range, Single

	//Multiple
	StartingLockerNum: any = 0;
	EndingLockerNum: any = 0;
	PaddingOptionID: any = 0;
	lstPaddingOption: any = [];
	AddLetterBefore: any = "";
	AddLetterAfter: any = "";

	//Single
	LockerNum: any = "";
	Assignable: any = true;
	Comments: any = "";

	loading: any = true;
	processing: any = false;
	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////

	loadPaddingOption() {
		this.loading = true;

		var result = this.LockerService.LockerPaddingOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstPaddingOption = response;

				this.PaddingOptionID = this.lstPaddingOption[0].ID;

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (String(this.LockerOption) == "Range") {
			this.onAddRange();
		} else {
			this.onAddSingle();
		}
	}

	onAddRange() {
		//
		// Error Handling?
		//
		if (this.StartingLockerNum > this.EndingLockerNum) {
			this.errorMessage = "Starting number must be <= ending number";
			return;
		}

		//
		// Create Request
		//
		this.processing = true;

		let parms: LockerInsertMultipleRequest = {
			StartingNumber: this.StartingLockerNum,
			EndingNumber: this.EndingLockerNum,
			PaddingOptionID: this.PaddingOptionID,
			LetterBefore: this.AddLetterBefore,
			LetterAfter: this.AddLetterAfter,
			SchoolID: this.School.SchoolID,
		};

		//
		// Call SP
		//
		var result = this.LockerService.LockerInsertMultiple(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				var data: any = response[0];

				if (data.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: data.Message,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: data.Message,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onAddSingle() {
		//
		// Error handling
		//

		if (this.LockerNum == "") {
			this.errorMessage = "Enter a locker number";
			return;
		}

		//
		// Check if the number has already been used for that school
		//
		this.CheckLockerExistsSingle();
	}

	CheckLockerExistsSingle() {
		this.processing = true;

		//
		// Create Request
		//

		let parms: LockerExistsRequest = {
			LockerID: -1,
			LockerNum: this.LockerNum,
			SchoolID: this.School.SchoolID,
		};

		//
		// Call WS
		//

		var result = this.LockerService.LockerExists(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Locker Already Exists
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Locker Number already exists for this school",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Doesn't Exist
					this.onFinishAddSingle();
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onFinishAddSingle() {
		//
		// Create Request
		//
		let parms: LockerInsertSingleRequest = {
			LockerNum: this.LockerNum,
			Assignable: this.Assignable == true ? 1 : 0,
			Comments: this.Comments,
			SchoolID: this.School.SchoolID,
		};

		//
		// Call SP
		//
		var result = this.LockerService.LockerInsertSingle(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Locker was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Locker",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.processing == true;
	}
	//////////////////////////////////////////////////////////////////
}
